import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { Money } from "./Money";

const TONES = {
  pending: "bg-amber-500/12 text-amber-500",
  approval_pending: "bg-violet-500/12 text-violet-500",
  approved: "bg-sky-500/12 text-sky-500",
  pending_confirmation: "bg-cyan-500/12 text-cyan-500",
  confirmed: "bg-emerald-500/12 text-emerald-500",
  paid: "bg-emerald-500/12 text-emerald-500",
  cancelled: "bg-muted text-muted-foreground",
};

export const DueRow = ({ row, onOpen }) => {
  const { t } = useTranslation();
  return (
    <NeuCard
      data-testid={`due-row-${row.id}`}
      onClick={() => onOpen?.(row)}
      className="cursor-pointer p-3 transition-all duration-200 hover:-translate-y-0.5"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="min-w-0 space-y-1">
          <p className="truncate text-sm font-black">{row.supplier_name || "—"}</p>
          <p className="num font-mono text-xs font-bold text-muted-foreground">{row.ref_number}</p>
        </div>
        <span className={`inline-flex items-center rounded-full px-3 py-1 text-[11px] font-bold ${TONES[row.state] || TONES.pending}`}>
          {t(`acct.dues.states.${row.state}`)}
        </span>
      </div>
      <div className="mt-2 grid grid-cols-3 gap-2 text-[11px]">
        <div>
          <p className="text-muted-foreground">{t("acct.dues.row.amount")}</p>
          <Money value={row.amount} currency={row.currency}
                 className="block text-xs font-black" />
        </div>
        <div>
          <p className="text-muted-foreground">{t("acct.dues.row.due")}</p>
          <p className="num font-mono font-bold" dir="ltr">{row.due_date || "—"}</p>
        </div>
        <div>
          <p className="text-muted-foreground">{t("acct.dues.row.installment")}</p>
          <p className="num font-mono font-bold">{row.installment_label || `#${row.installment_number}`}</p>
        </div>
      </div>
    </NeuCard>
  );
};
